/**
 * AlertImpactBadge — shows a warning icon when an entity is affected by active alerts.
 * Renders nothing when no impacts. Used on KPICard, DomainCard, etc.
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useAlertImpacts } from '../../hooks/useAlertImpacts';
import { Tooltip, TooltipTrigger, TooltipContent } from './tooltip';
import { ICON_PX } from './lib/iconSizes';

function AlertImpactBadge({ entityType, entityId }) {
  const { impacts, hasImpact } = useAlertImpacts(entityType, entityId);

  if (!hasImpact) return null;

  const firstAlert = impacts[0];
  const summary = firstAlert?.summary ?? firstAlert?.why ?? 'Active alert affecting this metric';

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex items-center text-amber-500 cursor-pointer ml-1">
          <AlertTriangle size={ICON_PX.md} />
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs">
        <p className="text-xs font-medium">{summary}</p>
        {impacts.length > 1 && (
          <p className="text-xs text-text-muted mt-1">+{impacts.length - 1} more alert(s)</p>
        )}
      </TooltipContent>
    </Tooltip>
  );
}

export default AlertImpactBadge;
